type TableDataWithCreated = {
  Created: string;
};

export const sortTableDataByDateTime = <T extends TableDataWithCreated>(
  tableData: T[]
): T[] => {
  const today = new Date().getTime();

  const sortedData = [...tableData].sort((a, b) => {
    const aDiff = today - new Date(a.Created).getTime();
    const bDiff = today - new Date(b.Created).getTime();
    return aDiff - bDiff;
  });

  return sortedData;
};
